export default function PartnersMarquee({ t }) {
  const items = t.partners || [];
  if (items.length === 0) return null;
  const list = [...items, ...items]; // duplicate for seamless loop
  return (
    <section className="bg-[#0A0807] py-10 sm:py-14 border-y border-white/5 overflow-hidden" data-testid="weddings-partners">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-10 text-center mb-7 sm:mb-9">
        <p className="text-[10px] sm:text-[11px] tracking-[0.3em] sm:tracking-[0.35em] text-[#F5C77A] mb-2 sm:mb-3 font-light">{t.partnersEyebrow}</p>
        <p className="text-xs sm:text-sm text-white/55 font-light max-w-xl mx-auto">{t.partnersTitle}</p>
      </div>
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-r from-[#0A0807] to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-24 bg-gradient-to-l from-[#0A0807] to-transparent z-10 pointer-events-none" />
        <div className="flex gap-10 sm:gap-16 animate-marquee whitespace-nowrap will-change-transform">
          {list.map((p, i) => (
            <span key={i} className="text-[11px] sm:text-[13px] tracking-[0.25em] sm:tracking-[0.3em] text-white/45 hover:text-[#F5C77A] transition font-medium uppercase select-none">
              {p}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
